import {useHistory} from '@aboutyou/router';
import {LoadingSpinner} from '@aboutyou/ui-components';
import React, {FC, useEffect} from 'react';
import styled from 'styled-components';
import {DEEP_LINKS} from './useDeepLinkOpener';

export const DeepLinkLoaderPage: FC<{
  openCouponWallet?: boolean;
  openNewsletter?: boolean;
}> = ({openCouponWallet, openNewsletter}) => {
  const {push, location} = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (openCouponWallet) {
      searchParams.set(DEEP_LINKS.cw, 'true');
      push(`/?${searchParams.toString()}`);
    }

    if (openNewsletter) {
      searchParams.set(DEEP_LINKS.newsletterSubscription, 'true');
      push(`/?${searchParams.toString()}`);
    }
  }, []);

  return (
    <Wrapper>
      <StyledLoadingSpinner size="80px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
  flex: 1;
  margin-top: 150px;
`;
